export const sectionUnderscore = {
  'Personal Information': 'personal_information',
  'Profile Picture': 'profile_picture',
  Headline: 'headline',
  Summary: 'summary',
  Experience: 'experience',
  Education: 'education',
  'Volunteer Experience': 'volunteer_experience',
  Skills: 'skills',
  Projects: 'projects',
  Publications: 'publications',
  Overall: 'overall',
}

export const sections = [
  'Profile Picture',
  'Personal Information',
  'Headline',
  'Summary',
  'Experience',
  'Education',
]

export const sectionsSequence = {
  'Profile Picture': 1,
  'Personal Information': 2,
  Headline: 3,
  Summary: 4,
  Experience: 5,
  Education: 6,
}

export const sectionUnderscoreFeedbackMapping = {
  'Personal Information': 'personal_information_feedback',
  'Profile Picture': 'profile_picture_feedback',
  Headline: 'headline_feedback',
  Summary: 'summary_feedback',
  Experience: 'experience_feedback',
  Education: 'education_feedback',
}

export const sectioNameToBackendVisitedSectioNameMapping = {
  'Personal Information': 'detailed_personal_info',
  'Profile Picture': 'detailed_profile_picture',
  Headline: 'detailed_headline',
  Summary: 'detailed_summary',
  Experience: 'detailed_experience',
  Education: 'detailed_education',
  'Summary Screen': 'summary',
  'Edit Personal Information': 'edit_personal_info',
  'Edit Profile Picture': 'edit_profile_picture',
  'Edit Headline': 'edit_headline',
  'Edit Summary': 'edit_summary',
  'Edit Experience': 'edit_experience',
  'Edit Education': 'edit_education',
}
